// extracted by css-extract-rspack-plugin
export default {"bui-Box":"a2t6Fd83HH42_rze"};